// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== LOGIN PAGE - Premium Side-by-side layout ===== */

.login-page {
  display: flex;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f1f5ff 0%, #eef2ff 50%, #f8faff 100%);
}

/* ===== LEFT PANEL - Animated Dark branding ===== */
.login-left {
  position: relative;
  flex: 0 0 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #0a3554 0%, #103d7a 35%, #1d4ed8 68%, #3b82f6 100%);
  overflow: hidden;
}

.login-left-glow {
  position: absolute;
  top: 10%;
  left: 25%;
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.28) 0%, rgba(37, 99, 235, 0.2) 40%, transparent 72%);
  border-radius: 50%;
  pointer-events: none;
  animation: loginGlowPulse 6s ease-in-out infinite;
}
.login-left-glow::after {
  content: '';
  position: absolute;
  bottom: -100px;
  right: -80px;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(191, 219, 254, 0.24) 0%, transparent 70%);
  border-radius: 50%;
  animation: loginGlowPulse 8s ease-in-out infinite reverse;
}

@keyframes loginGlowPulse {
  0%, 100% { transform: scale(1); opacity: 0.7; }
  50% { transform: scale(1.15); opacity: 1; }
}

.login-left-dots {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
}

.login-left::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(to bottom, transparent 0%, rgba(96, 165, 250, 0.5) 30%, rgba(96, 165, 250, 0.5) 70%, transparent 100%);
}

.login-left-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 42px 24px;
  animation: loginFadeUp 0.8s ease-out;
}

@keyframes loginFadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-logo-box {
  width: 110px;
  height: 110px;
  background: #fff;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06), 0 0 60px rgba(99,102,241,0.08);
  overflow: hidden;
  transition: transform 0.3s ease;
}
.login-logo-box:hover { transform: scale(1.04); }

.login-logo-img {
  width: 78px;
  height: 78px;
  object-fit: contain;
}

.login-logo-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-brand {
  font-size: 36px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 3px;
  margin: 0 0 12px;
  text-shadow: 0 2px 18px rgba(0,0,0,0.4);
}

.login-brand-sub {
  font-size: 21px;
  color: #ffffff;
  margin: 0 0 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.28;
  text-shadow: 0 2px 10px rgba(0,0,0,0.4);
}

.login-brand-co {
  font-size: 16px;
  color: #dbeafe;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 8px rgba(0,0,0,0.35);
}

/* ===== RIGHT PANEL ===== */
.login-right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: linear-gradient(180deg, #ffffff 0%, #f5fbff 100%);
}

.login-form-wrap {
  width: 100%;
  max-width: 400px;
  animation: loginFormSlide 0.6s ease-out 0.2s both;
}

@keyframes loginFormSlide {
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
}

.login-title {
  font-size: 30px;
  font-weight: 800;
  color: #0e3f63;
  margin: 0 0 8px;
  letter-spacing: -0.3px;
}

.login-subtitle {
  font-size: 15px;
  color: #365b75;
  margin: 0 0 36px;
  line-height: 1.6;
}

.login-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--clr-danger-bg);
  border: 1px solid var(--clr-danger-border);
  border-radius: 10px;
  color: var(--clr-danger-dark);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 20px;
  animation: loginShake 0.4s ease;
}

@keyframes loginShake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}

.login-field { margin-bottom: 24px; }

.login-label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  color: #134868;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.login-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.login-input-icon {
  position: absolute;
  left: 14px;
  pointer-events: none;
  z-index: 1;
  transition: stroke 0.2s;
}
.login-input-wrap:focus-within .login-input-icon { stroke: #2563eb !important; }

.login-input {
  width: 100%;
  padding: 14px 14px 14px 44px;
  font-size: 15px;
  font-family: inherit;
  border: 1.5px solid #b8d4e3;
  border-radius: 12px;
  background: #f3f9fc;
  color: #0d314b;
  transition: all 0.25s ease;
  outline: none;
}

.login-input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);
}

.login-input::placeholder { color: var(--clr-text-muted); font-weight: 400; }

.login-pw-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.login-pw-toggle:hover { opacity: 1; }

.login-btn {
  width: 100%;
  padding: 16px;
  font-size: 15.5px;
  font-weight: 700;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #1e40af 0%, #2563eb 52%, #3b82f6 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 18px rgba(30, 64, 175, 0.35);
  position: relative;
  overflow: hidden;
}

.login-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 200%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
  transition: left 0.5s ease;
}
.login-btn:hover::before { left: 100%; }

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.42);
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 45%, #60a5fa 100%);
}

.login-btn:active:not(:disabled) { transform: translateY(0); box-shadow: 0 4px 14px rgba(30, 64, 175, 0.3); }
.login-btn:disabled { opacity: 0.7; cursor: not-allowed; }

.login-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2.5px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: loginSpin 0.7s linear infinite;
}
@keyframes loginSpin { to { transform: rotate(360deg); } }

.login-footer {
  text-align: center;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.login-footer span { font-size: 11.5px; color: var(--clr-text-muted); }
.login-footer span:first-child { font-weight: 700; color: #24506b; }

@media (max-width: 900px) {
  .login-page {
    flex-direction: column;
    min-height: 100vh;
    overflow-y: auto;
  }
  .login-left {
    flex: 0 0 auto;
    padding: 28px 24px 24px;
  }
  .login-left-content {
    padding: 0;
  }
  .login-logo-box {
    width: 76px;
    height: 76px;
    border-radius: 18px;
    margin-bottom: 16px;
  }
  .login-logo-img { width: 52px; height: 52px; }
  .login-brand { font-size: 22px; margin-bottom: 6px; }
  .login-brand-sub { font-size: 15px; margin-bottom: 4px; }
  .login-brand-co { font-size: 13px; }
  .login-right {
    flex: 1 1;
    padding: 28px 20px 32px;
    align-items: flex-start;
  }
  .login-form-wrap { max-width: 100%; }
}

@media (max-width: 480px) {
  .login-page {
    min-height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .login-left {
    padding: 22px 20px 18px;
  }
  .login-logo-box {
    width: 68px;
    height: 68px;
    border-radius: 16px;
    margin-bottom: 12px;
  }
  .login-logo-img { width: 46px; height: 46px; }
  .login-brand { font-size: 20px; letter-spacing: 2px; margin-bottom: 4px; }
  .login-brand-sub { font-size: 13px; }
  .login-brand-co { font-size: 12px; }
  .login-right { padding: 24px 16px 28px; }
  .login-title { font-size: 22px; margin-bottom: 6px; }
  .login-subtitle { font-size: 13px; margin-bottom: 24px; }
  .login-form-wrap { max-width: 100%; }
  .login-input { font-size: 14px; padding: 12px 12px 12px 40px; }
  .login-btn { padding: 14px; font-size: 14px; }
  .login-footer { margin-top: 24px; }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAGzD;EACE,aAAa;EACb,iBAAiB;EACjB,mEAAmE;EACnE,0EAA0E;AAC5E;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uFAAuF;EACvF,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6GAA6G;EAC7G,kBAAkB;EAClB,oBAAoB;EACpB,iDAAiD;AACnD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kIAAkI;AACpI;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yGAAyG;EACzG,gBAAgB;EAChB,+BAA+B;AACjC;AACA,wBAAwB,sBAAsB,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,eAAe,mBAAmB,EAAE;;AAEpC;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,uBAAuB;AACzB;AACA,mDAAmD,0BAA0B,EAAE;;AAE/E;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,4BAA4B,4BAA4B,EAAE,gBAAgB,EAAE;;AAE5E;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA,yBAAyB,UAAU,EAAE;;AAErC;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,0EAA0E;EAC1E,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,0BAA0B;AAC5B;AACA,2BAA2B,UAAU,EAAE;;AAEvC;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,0EAA0E;AAC5E;;AAEA,mCAAmC,wBAAwB,EAAE,6CAA6C,EAAE;AAC5G,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,uBAAuB,KAAK,yBAAyB,EAAE,EAAE;;AAEzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,qBAAqB,iBAAiB,EAAE,4BAA4B,EAAE;AACtE,iCAAiC,gBAAgB,EAAE,cAAc,EAAE;;AAEnE;EACE;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;EACA,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C,eAAe,eAAe,EAAE,kBAAkB,EAAE;EACpD,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;EACxD,kBAAkB,eAAe,EAAE;EACnC;IACE,SAAO;IACP,uBAAuB;IACvB,uBAAuB;EACzB;EACA,mBAAmB,eAAe,EAAE;AACtC;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;EACA,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C,eAAe,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EACzE,mBAAmB,eAAe,EAAE;EACpC,kBAAkB,eAAe,EAAE;EACnC,eAAe,uBAAuB,EAAE;EACxC,eAAe,eAAe,EAAE,kBAAkB,EAAE;EACpD,kBAAkB,eAAe,EAAE,mBAAmB,EAAE;EACxD,mBAAmB,eAAe,EAAE;EACpC,eAAe,eAAe,EAAE,4BAA4B,EAAE;EAC9D,aAAa,aAAa,EAAE,eAAe,EAAE;EAC7C,gBAAgB,gBAAgB,EAAE;AACpC","sourcesContent":["/* ===== LOGIN PAGE - Premium Side-by-side layout ===== */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n.login-page {\n  display: flex;\n  min-height: 100vh;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f1f5ff 0%, #eef2ff 50%, #f8faff 100%);\n}\n\n/* ===== LEFT PANEL - Animated Dark branding ===== */\n.login-left {\n  position: relative;\n  flex: 0 0 480px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #0a3554 0%, #103d7a 35%, #1d4ed8 68%, #3b82f6 100%);\n  overflow: hidden;\n}\n\n.login-left-glow {\n  position: absolute;\n  top: 10%;\n  left: 25%;\n  width: 350px;\n  height: 350px;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.28) 0%, rgba(37, 99, 235, 0.2) 40%, transparent 72%);\n  border-radius: 50%;\n  pointer-events: none;\n  animation: loginGlowPulse 6s ease-in-out infinite;\n}\n.login-left-glow::after {\n  content: '';\n  position: absolute;\n  bottom: -100px;\n  right: -80px;\n  width: 250px;\n  height: 250px;\n  background: radial-gradient(circle, rgba(191, 219, 254, 0.24) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: loginGlowPulse 8s ease-in-out infinite reverse;\n}\n\n@keyframes loginGlowPulse {\n  0%, 100% { transform: scale(1); opacity: 0.7; }\n  50% { transform: scale(1.15); opacity: 1; }\n}\n\n.login-left-dots {\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);\n  background-size: 28px 28px;\n  pointer-events: none;\n}\n\n.login-left::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 1px;\n  height: 100%;\n  background: linear-gradient(to bottom, transparent 0%, rgba(96, 165, 250, 0.5) 30%, rgba(96, 165, 250, 0.5) 70%, transparent 100%);\n}\n\n.login-left-content {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  padding: 42px 24px;\n  animation: loginFadeUp 0.8s ease-out;\n}\n\n@keyframes loginFadeUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.login-logo-box {\n  width: 110px;\n  height: 110px;\n  background: #fff;\n  border-radius: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 32px;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.06), 0 0 60px rgba(99,102,241,0.08);\n  overflow: hidden;\n  transition: transform 0.3s ease;\n}\n.login-logo-box:hover { transform: scale(1.04); }\n\n.login-logo-img {\n  width: 78px;\n  height: 78px;\n  object-fit: contain;\n}\n\n.login-logo-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-brand {\n  font-size: 36px;\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: 3px;\n  margin: 0 0 12px;\n  text-shadow: 0 2px 18px rgba(0,0,0,0.4);\n}\n\n.login-brand-sub {\n  font-size: 21px;\n  color: #ffffff;\n  margin: 0 0 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: 1.28;\n  text-shadow: 0 2px 10px rgba(0,0,0,0.4);\n}\n\n.login-brand-co {\n  font-size: 16px;\n  color: #dbeafe;\n  margin: 0;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 8px rgba(0,0,0,0.35);\n}\n\n/* ===== RIGHT PANEL ===== */\n.login-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  background: linear-gradient(180deg, #ffffff 0%, #f5fbff 100%);\n}\n\n.login-form-wrap {\n  width: 100%;\n  max-width: 400px;\n  animation: loginFormSlide 0.6s ease-out 0.2s both;\n}\n\n@keyframes loginFormSlide {\n  from { opacity: 0; transform: translateX(20px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.login-title {\n  font-size: 30px;\n  font-weight: 800;\n  color: #0e3f63;\n  margin: 0 0 8px;\n  letter-spacing: -0.3px;\n}\n\n.login-subtitle {\n  font-size: 15px;\n  color: #365b75;\n  margin: 0 0 36px;\n  line-height: 1.6;\n}\n\n.login-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--clr-danger-bg);\n  border: 1px solid var(--clr-danger-border);\n  border-radius: 10px;\n  color: var(--clr-danger-dark);\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 20px;\n  animation: loginShake 0.4s ease;\n}\n\n@keyframes loginShake {\n  0%, 100% { transform: translateX(0); }\n  20% { transform: translateX(-6px); }\n  40% { transform: translateX(6px); }\n  60% { transform: translateX(-4px); }\n  80% { transform: translateX(4px); }\n}\n\n.login-field { margin-bottom: 24px; }\n\n.login-label {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #134868;\n  letter-spacing: 0.8px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.login-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.login-input-icon {\n  position: absolute;\n  left: 14px;\n  pointer-events: none;\n  z-index: 1;\n  transition: stroke 0.2s;\n}\n.login-input-wrap:focus-within .login-input-icon { stroke: #2563eb !important; }\n\n.login-input {\n  width: 100%;\n  padding: 14px 14px 14px 44px;\n  font-size: 15px;\n  font-family: inherit;\n  border: 1.5px solid #b8d4e3;\n  border-radius: 12px;\n  background: #f3f9fc;\n  color: #0d314b;\n  transition: all 0.25s ease;\n  outline: none;\n}\n\n.login-input:focus {\n  border-color: #2563eb;\n  background: #fff;\n  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.2);\n}\n\n.login-input::placeholder { color: var(--clr-text-muted); font-weight: 400; }\n\n.login-pw-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  opacity: 0.5;\n  transition: opacity 0.2s;\n}\n.login-pw-toggle:hover { opacity: 1; }\n\n.login-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 15.5px;\n  font-weight: 700;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #1e40af 0%, #2563eb 52%, #3b82f6 100%);\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 8px;\n  letter-spacing: 0.3px;\n  box-shadow: 0 4px 18px rgba(30, 64, 175, 0.35);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 200%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);\n  transition: left 0.5s ease;\n}\n.login-btn:hover::before { left: 100%; }\n\n.login-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.42);\n  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 45%, #60a5fa 100%);\n}\n\n.login-btn:active:not(:disabled) { transform: translateY(0); box-shadow: 0 4px 14px rgba(30, 64, 175, 0.3); }\n.login-btn:disabled { opacity: 0.7; cursor: not-allowed; }\n\n.login-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2.5px solid rgba(255,255,255,0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: loginSpin 0.7s linear infinite;\n}\n@keyframes loginSpin { to { transform: rotate(360deg); } }\n\n.login-footer {\n  text-align: center;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.login-footer span { font-size: 11.5px; color: var(--clr-text-muted); }\n.login-footer span:first-child { font-weight: 700; color: #24506b; }\n\n@media (max-width: 900px) {\n  .login-page {\n    flex-direction: column;\n    min-height: 100vh;\n    overflow-y: auto;\n  }\n  .login-left {\n    flex: 0 0 auto;\n    padding: 28px 24px 24px;\n  }\n  .login-left-content {\n    padding: 0;\n  }\n  .login-logo-box {\n    width: 76px;\n    height: 76px;\n    border-radius: 18px;\n    margin-bottom: 16px;\n  }\n  .login-logo-img { width: 52px; height: 52px; }\n  .login-brand { font-size: 22px; margin-bottom: 6px; }\n  .login-brand-sub { font-size: 15px; margin-bottom: 4px; }\n  .login-brand-co { font-size: 13px; }\n  .login-right {\n    flex: 1;\n    padding: 28px 20px 32px;\n    align-items: flex-start;\n  }\n  .login-form-wrap { max-width: 100%; }\n}\n\n@media (max-width: 480px) {\n  .login-page {\n    min-height: 100vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .login-left {\n    padding: 22px 20px 18px;\n  }\n  .login-logo-box {\n    width: 68px;\n    height: 68px;\n    border-radius: 16px;\n    margin-bottom: 12px;\n  }\n  .login-logo-img { width: 46px; height: 46px; }\n  .login-brand { font-size: 20px; letter-spacing: 2px; margin-bottom: 4px; }\n  .login-brand-sub { font-size: 13px; }\n  .login-brand-co { font-size: 12px; }\n  .login-right { padding: 24px 16px 28px; }\n  .login-title { font-size: 22px; margin-bottom: 6px; }\n  .login-subtitle { font-size: 13px; margin-bottom: 24px; }\n  .login-form-wrap { max-width: 100%; }\n  .login-input { font-size: 14px; padding: 12px 12px 12px 40px; }\n  .login-btn { padding: 14px; font-size: 14px; }\n  .login-footer { margin-top: 24px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
